An array of methods for applying to the position.

If no methods are provided, SEEK's Apply Form will be used to receive candidate applications.
SEEK's Apply Form will emit a `CandidateApplicationCreated` event that points to a `CandidateProfile` object.
